/* eslint-disable react/no-array-index-key */
import BulletLink from '../bulletLink/bulletLink';
import './bulletLinkList.css';

function BulletLinkList(props) {
  const { points = [] } = props;
  return (
    <div className="bulletLinks">
      <ul>
        {points.map(({ pointText, pointLink, pointlinkText }, index) => (
          <BulletLink
            key={index}
            text={pointText}
            link={pointLink}
            linkText={pointlinkText}
          />
        ))}
      </ul>
    </div>
  );
}

export default BulletLinkList;
